import React from "react"
import { useLoaderData } from "react-router";
import ShowInternalEditApp from "./edit/AppForInternal";
import { mapShowToShowInfo } from "./edit/utils";
import moment from "moment";
import { companyToArtist } from "utilities/companyUtils";
import ShowExternalEditApp from "./edit/AppForExternal";

export const ShowEditAppForInternal = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowEditInternalFrontModel>();

  return <ShowInternalEditApp
    exclusivityClause={viewModel.exclusivityClause}
    type={{ existingShowId: viewModel.show.showId }}
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    itineraryPanel={viewModel.itinerarySidebarPanel}
    hasAccessToAllArtists={viewModel.hasAccessToAllArtists}
    initialValues={mapShowToShowInfo(viewModel.show)}
  />
}

export const ShowEditAppForExternal = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowEditExternalFrontModel>();

  return <ShowExternalEditApp
    type={{ existingShowId: viewModel.show.showId }}
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    initialValues={{
      production: viewModel.show.production,
      showDates: {
        startDisplayDate: moment.utc(viewModel.show.dateTime.startDisplay),
        endDisplayDate: moment.utc(viewModel.show.dateTime.endDisplay),
        mode: viewModel.show.dateTime.mode,
        timeOfPerformance: viewModel.show.dateTime.customFallbackTime
      },
      status: viewModel.show.status,
      eventName: viewModel.show.eventName,
      eventWebsite: viewModel.show.eventWebsite ?? "",

      artist: companyToArtist(viewModel.show.artist),

      freefieldValues: viewModel.show.freeFields
    }}
  />
}
